import BigNumber from 'bignumber.js'
import { BIG_ZERO } from 'config/constants/number'
import { Token } from 'config/types'
import { RowBetween } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import Text from 'UIKit/Text'
import { getFullDisplayBalance } from 'utils/formatBalance'

export type DepositRolloverOverviewProps = {
  selectedToken: Token
  totalDepositRollover: BigNumber
  openDepositRollovermodal: () => void
}

const DepositRolloverOverview: React.FC<DepositRolloverOverviewProps> = ({
  openDepositRollovermodal,
  selectedToken,
  totalDepositRollover,
}) => {
  return (
    <>
      {totalDepositRollover.isGreaterThan(BIG_ZERO) && (
        <RowBetween
          style={{
            fontSize: 'var(--pm-text-note-size, 12px)',
          }}
          gap="4px"
        >
          <Text fontSize="1em" color="var(--pm-text-note-color)">
            <Trans
              i18nKey="lockDepositRolloverAmount"
              components={{
                highlight_tag: (
                  <Text
                    fontSize="1em"
                    color="strokeAlt3"
                    fontWeight={500}
                    style={{
                      textDecoration: 'underline',
                      display: 'inline',
                    }}
                    onClick={openDepositRollovermodal}
                  />
                ),
              }}
            />
          </Text>
          <Text fontSize="1em" color="white" as="span">
            {getFullDisplayBalance(totalDepositRollover, 0, 5)} {selectedToken.name}
          </Text>
        </RowBetween>
      )}
    </>
  )
}

export default DepositRolloverOverview
